// extracted by mini-css-extract-plugin
module.exports = {"font-family-light":"TreatwellSansWeb-Light","wrapper":"VenueSearch-module--wrapper--16a0f7","title":"VenueSearch-module--title--94a2d6"};